import axios from 'axios';
import { checkOnScreenEls } from '../common/on-screen';

import '../../sass/blocks/news-list.scss';

(() => {
    const $newsLists = document.querySelectorAll('.news-list');

    if (!$newsLists) return;

    $newsLists.forEach($newsList => {
        const abortController = new AbortController();

        const $resultsList = $newsList.querySelector('.news-list__list');
        const $noResults = $newsList.querySelector('.news-list__no-results');
        const $loadMore = $newsList.querySelector('.news-list__load-more');

        const $loadMoreNonce = $loadMore?.querySelector('input[name="armourcoat_theme_load_more_news_wpnonce"]');
        const $loadMoreKeyword = $loadMore?.querySelector('input[name="keyword"]');
        const $loadMorePage = $loadMore?.querySelector('input[name="news_page"]');
        const $loadMoreIsFirstHeading = $loadMore?.querySelector('input[name="is_first_heading"]');
        const $loadMorePostsPerPage = $loadMore?.querySelector('input[name="posts_per_page"]');

        const setNewsItems = (data) => {
            // If results returned show results list and hide 'no results' message
            if (data?.html) {
                if (data?.page === 1) {
                    $resultsList.innerHTML = data.html;
                } else {
                    $resultsList.insertAdjacentHTML('beforeend', data.html);
                }

                $resultsList.classList.add('news-list__list--show');
                $noResults.classList.remove('news-list__no-results--show');

                checkOnScreenEls();
            }

            // If no results returned show 'no results' message and hide results
            if (!data?.html) {
                if (data?.page === 1) {
                    $resultsList.innerHTML = '';
                }

                $resultsList.classList.remove('news-list__list--show');
                $noResults.classList.add('news-list__no-results--show');
            }

            // Show/hide load more button
            if (data?.post_count >= data?.found_posts || !data?.html) {
                $loadMore.classList.remove('news-list__load-more--show');
            } else {
                $loadMore.classList.add('news-list__load-more--show');
            }

            // Set load more args
            if ($loadMoreKeyword) $loadMoreKeyword.value = keyword ?? '';
            if ($loadMorePage) $loadMorePage.value = data?.page && !isNaN(data?.page) ? parseInt(data.page) + 1 : 1;

            // Build new URL
            const url = new URL(window.location.href);
            const searchParams = url.searchParams;

            // Add block_anchor to URL
            if ($newsList?.id) {
                searchParams.set('block_anchor', $newsList.id);
            } else {
                searchParams.delete('block_anchor');
            }

            // Add page number to URL
            searchParams.set('news_page', data?.page ?? 1);

            // Update URL
            window.history.replaceState('', '', url.toString());
        };

        const loadMore = () => {
            $loadMore.classList.add('news-list__load-more--loading');

            axios.get(GLOBALS.AJAX_URL, {
                signal: abortController.signal,
                params: {
                    action: 'armourcoat_theme_ajax_load_more_news',
                    nonce: $loadMoreNonce?.value ?? null,
                    page: $loadMorePage?.value ?? null,
                    posts_per_page: $loadMorePostsPerPage?.value ?? null,
                    is_first_heading: $loadMoreIsFirstHeading?.value === '1'
                }
            }).then(response => {
                setNewsItems(response?.data?.data);
            }).catch(error => {
                console.log(error);

                //$loadMore.submit();
            }).finally(() => {
                $loadMore.classList.remove('news-list__load-more--loading');
            });
        };

        const initLoadMore = () => {
            if (!$loadMore) return;

            $loadMore.addEventListener('submit', e => {
                e.preventDefault();

                loadMore();
            });
        };

        initLoadMore();
    });
})();
